(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function() {
    try {
      const isReload = window.performance && window.performance.getEntriesByType 
        ? window.performance.getEntriesByType('navigation').some(nav => nav.type === 'reload')
        : false;
      
      if (isReload) {
        const currentUrl = new URL(window.location.href);
        if (currentUrl.searchParams.has('page')) {
          currentUrl.searchParams.delete('page');
          const hash = window.location.hash;
          if (hash) currentUrl.hash = hash;
          window.location.href = currentUrl.toString();
          return;
        }
      }
    } catch (e) {
      console.warn('URL Error:', e);
    }
    
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    
    requestAnimationFrame(function() {
      try {
        const url = new URL(window.location.href);
        const pageParam = url.searchParams.get('page');
        const hasHash = window.location.hash && window.location.hash.length > 1;
        
        if (!hasHash && (!pageParam || pageParam === '1')) {
          window.scrollTo(0, 0);
        } else if (hasHash) {
          setTimeout(function() {
            const element = document.getElementById(window.location.hash.slice(1));
            if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 150);
        }
      } catch (e) {
        window.scrollTo(0, 0);
      }
    });

    // iOS Specific Memory Management
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isIOS && 'IntersectionObserver' in window) {
      // Use Intersection Observer to let Safari "forget" off-screen items
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          // Setting visibility to hidden for off-screen cards saves massive GPU RAM
          entry.target.style.visibility = entry.isIntersecting ? 'visible' : 'hidden';
        });
      }, { rootMargin: '400px' });

      document.querySelectorAll('.product-grid__item').forEach(item => observer.observe(item));
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
